import { EncryptService } from './../utils/encrypt.service';
import { LocalService } from './../storage/local.service';
import { ConfigService } from './../config/config.service';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_ENDPOINT } from '../config/config';

@Injectable({
  providedIn: 'root'
})
export class AtencionService {
  headers = new HttpHeaders({
    'accept': 'application/json',
    'Content-Type': 'application/json',
  });

  headers1 = new HttpHeaders({
    'accept': 'application/json',
  });


  constructor(
    private httpClient: HttpClient,
    private config: ConfigService,
    private localSecureService: LocalService,
    private encriptado: EncryptService
  ) { }

  async getMotivos( idTurno:string) {
    //const config =  await this.config.getConfig();
    const customer = this.localSecureService.getValue('customer');
    const params = `Idturno=${idTurno}`;
    const url = `${API_ENDPOINT.endpoint}/${customer['slug']}/listarmotivos?${params}`;

    try {
      return await this.httpClient.post(url, { headers: this.headers1 }).toPromise();
    } catch (error:any) {
      return { status: false, code: error.error.status, message: error.error.message };
    }
  }

  async ingresaMotivos(data:any){
    //const config = await this.config.getConfig();
    const customer = this.localSecureService.getValue('customer');
    const url = `${API_ENDPOINT.endpoint}/${customer['slug']}/ingmotivos`;


    try {
      return await this.httpClient.post(url, data, { headers: this.headers }).toPromise();
    } catch (error:any) {
      return { status: false, code: error.error.status, message: error.error.title };
    }
  }

}
